import React from "react";
import { Route } from "react-router-dom";
import Quotation from "../../../containers/modules/purchasing/quotation";
import AccessControl from "../../../components/utilities/Class/AccessControl";

export default function QuotationRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="quotation"
      index
      element={
        <AccessControl
          name={"Quotation Request List"}
          auth={authUser}
          component={() => <Quotation />}
        />
      }
    ></Route>
  );
}
